<template>
    <div class="call-wrapper">
        <a :href="'https://api.whatsapp.com/send?phone=' + webset.whatsapp + '&msg=' + webset.sayhi"> <img
                src="@/assets/images/what-app-icon.png" alt=""></a>
    </div>
</template>
<script>

export default {

    data() {
        return {
            webset: []
        }
    },
    created(option) {

        this.getSet()
    },
    methods: {

        async getSet() {
            console.log('go...');
            let fdata = { do: 'getSet', goto: 'webset' }
            let res = await this.$api.funk(fdata)
            this.webset = res
            console.log('whatsapp：' + this.webset.whatsapp);
        },

    },
}
</script>
<style lang="scss" scoped>
.call-wrapper {
    width: 0.48rem;
    height: 0.48rem;
    position: fixed;
    right: 0.32rem;
    bottom: 1.5rem;
    cursor: pointer;
    z-index: 100;

    img {
        width: 100%;
        height: 100%;
        display: block;
    }
}

@media (max-width: 750px) {
    .call-wrapper {
        width: 1.1rem;
        height: 1.1rem;
        bottom: 1.5rem;
    }

}
</style>